// packages/ui/src/tools/terminal/closeGuard.ts
import type { CloseGuardReason, ToolHost } from '@slate/core';
import { useToolsStore } from '../toolsStore';

/**
 * Contributes a close-guard reason for every terminal instance that still has a
 * running foreground process.
 *
 * We read the cached `busy` flag that TerminalView's 1Hz poll keeps current on
 * each instance. Pulling a fresh `isBusy()` per session at close-time would
 * require holding `PtySession` refs in the store (non-serializable); the cached
 * flag is the documented signal the close-guard consumes.
 */
export async function terminalCloseGuard(host: ToolHost): Promise<CloseGuardReason[]> {
  void host;
  const instances = useToolsStore
    .getState()
    .instances.filter((i) => i.toolId === 'terminal' && i.busy);
  return instances.map((i) => ({
    toolId: 'terminal',
    instanceId: i.id,
    title: i.title || 'Terminal',
    severity: 'confirm' as const,
  }));
}
